import { SERVICES } from '../actionTypes';

export const fetchServices = (action) => ({
  type: SERVICES.FETCH,
  payload: action.payload,
});
